import { render, staticRenderFns } from "./SuggestedCategories.vue?vue&type=template&id=647b0c58&scoped=true"
import script from "./SuggestedCategories.vue?vue&type=script&lang=js"
export * from "./SuggestedCategories.vue?vue&type=script&lang=js"
import style0 from "./SuggestedCategories.vue?vue&type=style&index=0&id=647b0c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647b0c58",
  null
  
)

export default component.exports